import React, { useState, useEffect } from 'react';
import LayoutDashboardHeader from './components/LayoutDashboardHeader';
import DashboardStatsCard from './components/DashboardStatsCard';
import DashboardOperationList from './components/DashboardOperationList';
import OperationStartForm from './components/OperationStartForm';
import OperationFinishForm from './components/OperationFinishForm';
import OperarioHistory from './components/OperarioHistory';
import PlantSelector from './components/PlantSelector';
import WorkCenterList from './components/WorkCenterList';
import OperarioSelectionModal from './components/OperarioSelectionModal';
import UnitsInputModal from './components/UnitsInputModal';
import StatisticsDashboard from './components/StatisticsDashboard';
import DashboardPlantWorkCenterFilters from './components/DashboardPlantWorkCenterFilters';
import ConsumptionModal from './components/ConsumptionModal';

import { defaultOperarios } from './mock/operarios';
import { defaultOperaciones } from './mock/operaciones';
import { defaultPlantas } from './mock/plantas';

const App = () => {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [operaciones, setOperaciones] = useState(defaultOperaciones);
  const operarios = defaultOperarios;
  const plantas = defaultPlantas;
  const [currentTime, setCurrentTime] = useState(new Date());
  const [selectedOperationToFinishId, setSelectedOperationToFinishId] = useState(null);

  const [selectedPlantId, setSelectedPlantId] = useState(null);
  const [selectedWorkCenterId, setSelectedWorkCenterId] = useState(null);
  const [plantasViewSearchTerm, setPlantasViewSearchTerm] = useState('');
  
  // Estados para el filtro del dashboard
  const [dashboardSelectedFilterPlantId, setDashboardSelectedFilterPlantId] = useState('');
  const [dashboardSelectedFilterWorkCenterId, setDashboardSelectedFilterWorkCenterId] = useState('');
  const [dashboardSelectedFilterStatus, setDashboardSelectedFilterStatus] = useState('pendiente'); // Por defecto, mostrar pendientes
  const [dashboardSelectedProductFilter, setDashboardSelectedProductFilter] = useState(''); // Nuevo estado para filtro de producto
  const [dashboardSelectedOperarioFilterId, setDashboardSelectedOperarioFilterId] = useState(''); // Nuevo estado para filtro de operario

  const [showOperarioSelectionModal, setShowOperarioSelectionModal] = useState(false);
  const [operationIdToAssign, setOperationIdToAssign] = useState(null);

  const [showUnitsInputModal, setShowUnitsInputModal] = useState(false);
  const [operationIdForUnitsInput, setOperationIdForUnitsInput] = useState(null);
  const [currentUnitsForUnitsInput, setCurrentUnitsForUnitsInput] = useState(0);
  const [unitsInputModalContext, setUnitsInputModalContext] = useState('');

  const [showConsumptionModal, setShowConsumptionModal] = useState(false);
  const [selectedOperationIdForConsumos, setSelectedOperationIdForConsumos] = useState(null);
  const [selectedOperationConsumos, setSelectedOperationConsumos] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleStartOperation = ({ operarioId, pendingOperationId }) => {
    setOperaciones(prevOps =>
      prevOps.map(op =>
        op.id === pendingOperationId
          ? { ...op, operarioId, estado: 'iniciada', inicio: new Date().toISOString() }
          : op
      )
    );
    setCurrentPage('dashboard');
  };

  const handleFinishOperation = (operationId, units) => {
    setOperaciones(prevOps =>
      prevOps.map(op =>
        op.id === operationId
          ? { ...op, estado: 'terminada', fin: new Date().toISOString(), unidades: units }
          : op
      )
    );
    setCurrentPage('dashboard');
  };

  const handlePauseOperationRequest = (operationId, currentUnits) => {
    setOperationIdForUnitsInput(operationId);
    setCurrentUnitsForUnitsInput(currentUnits);
    setUnitsInputModalContext('pause');
    setShowUnitsInputModal(true);
  };

  const handleFinishOperationRequest = (operationId, currentUnits) => {
    setOperationIdForUnitsInput(operationId);
    setCurrentUnitsForUnitsInput(currentUnits);
    setUnitsInputModalContext('finish');
    setShowUnitsInputModal(true);
  };

  const handleUnitsInputConfirm = (operationId, units) => {
    if (unitsInputModalContext === 'pause') {
      setOperaciones(prevOps =>
        prevOps.map(op =>
          op.id === operationId
            ? { ...op, estado: 'pausada', ultimaPausaInicio: new Date().toISOString(), operarioId: null, unidades: units }
            : op
        )
      );
    } else if (unitsInputModalContext === 'finish') {
      setOperaciones(prevOps =>
        prevOps.map(op =>
          op.id === operationId
            ? { ...op, estado: 'terminada', fin: new Date().toISOString(), unidades: units }
            : op
        )
      );
    }
    setShowUnitsInputModal(false);
    setOperationIdForUnitsInput(null);
    setCurrentUnitsForUnitsInput(0);
    setUnitsInputModalContext('');
    setCurrentPage('dashboard');
  };

  const handleResumeOperationClick = (operationId) => {
    setOperationIdToAssign(operationId);
    setShowOperarioSelectionModal(true);
  };

  const handleSelectPlant = (plantId) => {
    setSelectedPlantId(plantId);
    setSelectedWorkCenterId(null);
    setPlantasViewSearchTerm('');
    // Limpiar filtros del dashboard al cambiar de vista principal
    setDashboardSelectedFilterPlantId('');
    setDashboardSelectedFilterWorkCenterId('');
    setDashboardSelectedFilterStatus('pendiente');
    setDashboardSelectedProductFilter('');
    setDashboardSelectedOperarioFilterId('');
  };

  const handleSelectWorkCenter = (workCenterId) => {
    setSelectedWorkCenterId(workCenterId);
    setPlantasViewSearchTerm('');
  };

  const handleStartPendingOperationClick = (operationId) => {
    setOperationIdToAssign(operationId);
    setShowOperarioSelectionModal(true);
  };

  const handleOperarioSelectedForPending = (operarioId) => {
    if (operationIdToAssign && operarioId) {
      setOperaciones(prevOps =>
        prevOps.map(op => {
          if (op.id === operationIdToAssign) {
            if (op.estado === 'pendiente') {
              return { ...op, operarioId, estado: 'iniciada', inicio: new Date().toISOString() };
            } else if (op.estado === 'pausada') {
              const pauseDuration = new Date().getTime() - new Date(op.ultimaPausaInicio).getTime();
              return {
                ...op,
                operarioId,
                estado: 'iniciada',
                totalTiempoPausadoMs: op.totalTiempoPausadoMs + pauseDuration,
                ultimaPausaInicio: null,
              };
            }
          }
          return op;
        })
      );
    }
    setOperationIdToAssign(null);
    setShowOperarioSelectionModal(false);
    setCurrentPage('dashboard');
  };

  // Función para abrir el modal de consumos
  const handleConsumptionClick = (operationId, consumos) => {
    setSelectedOperationIdForConsumos(operationId);
    setSelectedOperationConsumos(consumos);
    setShowConsumptionModal(true);
  };

  // Función para actualizar los consumos de una operación
  const handleUpdateConsumos = (operationId, newConsumos) => {
    setOperaciones(prevOps =>
      prevOps.map(op =>
        op.id === operationId
          ? { ...op, consumos: newConsumos }
          : op
      )
    );
  };

  // Lógica para filtrar operaciones según los filtros del dashboard
  const getFilteredDashboardOperations = () => {
    let filteredOps = operaciones;

    if (dashboardSelectedFilterPlantId) {
      const centrosDePlanta = plantas.find(p => p.id === dashboardSelectedFilterPlantId)?.centrosTrabajo.map(ct => ct.id) || [];
      filteredOps = filteredOps.filter(op => centrosDePlanta.includes(op.centroTrabajoId));
    }

    if (dashboardSelectedFilterWorkCenterId) {
      filteredOps = filteredOps.filter(op => op.centroTrabajoId === dashboardSelectedFilterWorkCenterId);
    }

    return filteredOps;
  };

  const dashboardOperationsFilteredByLocation = getFilteredDashboardOperations();

  const pendingCount = dashboardOperationsFilteredByLocation.filter(op => op.estado === 'pendiente').length;
  const initiatedCount = dashboardOperationsFilteredByLocation.filter(op => op.estado === 'iniciada').length;
  const completedCount = dashboardOperationsFilteredByLocation.filter(op => op.estado === 'terminada').length;
  const pausedCount = dashboardOperationsFilteredByLocation.filter(op => op.estado === 'pausada').length;

  const currentPlant = plantas.find(p => p.id === selectedPlantId);
  const centrosTrabajoDePlanta = currentPlant ? currentPlant.centrosTrabajo : [];

  // Lógica para el filtro de dashboard
  const dashboardCurrentPlant = plantas.find(p => p.id === dashboardSelectedFilterPlantId);
  const dashboardCentrosTrabajoDePlanta = dashboardCurrentPlant ? dashboardCurrentPlant.centrosTrabajo : [];

  return (
    <div className="min-h-screen bg-gray-100 font-sans antialiased">
      <LayoutDashboardHeader
        setCurrentPage={setCurrentPage}
        plantas={plantas}
        onSelectPlant={handleSelectPlant}
      />

      <main className="p-8">
        {currentPage === 'dashboard' && (
          <div className="space-y-8">
            {/* Tarjetas de estadísticas que ahora también filtran por estado */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <DashboardStatsCard
                title="Pendientes"
                value={pendingCount}
                valueTextColorClass="text-amber-600"
                cardBgColorClass="bg-amber-50"
                isSelected={dashboardSelectedFilterStatus === 'pendiente'}
                onClick={() => setDashboardSelectedFilterStatus('pendiente')}
              />
              <DashboardStatsCard
                title="Iniciadas"
                value={initiatedCount}
                valueTextColorClass="text-indigo-600"
                cardBgColorClass="bg-indigo-50"
                isSelected={dashboardSelectedFilterStatus === 'iniciada'}
                onClick={() => setDashboardSelectedFilterStatus('iniciada')}
              />
              <DashboardStatsCard
                title="Pausadas"
                value={pausedCount}
                valueTextColorClass="text-red-600"
                cardBgColorClass="bg-red-50"
                isSelected={dashboardSelectedFilterStatus === 'pausada'}
                onClick={() => setDashboardSelectedFilterStatus('pausada')}
              />
              <DashboardStatsCard
                title="Terminadas"
                value={completedCount}
                valueTextColorClass="text-emerald-600"
                cardBgColorClass="bg-emerald-50"
                isSelected={dashboardSelectedFilterStatus === 'terminada'}
                onClick={() => setDashboardSelectedFilterStatus('terminada')}
              />
            </div>

            {/* Sección de filtros de Planta y Centro de Trabajo */}
            <DashboardPlantWorkCenterFilters
              plantas={plantas}
              centrosTrabajoDePlanta={dashboardCentrosTrabajoDePlanta}
              selectedPlantFilterId={dashboardSelectedFilterPlantId}
              onSelectPlantFilter={setDashboardSelectedFilterPlantId}
              selectedWorkCenterFilterId={dashboardSelectedFilterWorkCenterId}
              onSelectWorkCenterFilter={setDashboardSelectedFilterWorkCenterId}
            />

            {/* Una sola lista de operaciones filtrada por los nuevos controles */}
            <DashboardOperationList
              operaciones={operaciones}
              operarios={operarios}
              plantas={plantas}
              title={`Operaciones ${dashboardSelectedFilterStatus.charAt(0).toUpperCase() + dashboardSelectedFilterStatus.slice(1)}`}
              filterStatus={dashboardSelectedFilterStatus}
              filterCentroTrabajoId={dashboardSelectedFilterWorkCenterId}
              selectedPlantFilterId={dashboardSelectedFilterPlantId}
              currentTime={currentTime}
              onPauseOperationRequest={handlePauseOperationRequest}
              onFinishOperationRequest={handleFinishOperationRequest}
              onStartPendingOperation={handleStartPendingOperationClick}
              onResumeOperation={handleResumeOperationClick}
              selectedProductFilter={dashboardSelectedProductFilter}
              onProductFilterChange={setDashboardSelectedProductFilter}
              selectedOperarioFilterId={dashboardSelectedOperarioFilterId}
              onOperarioFilterChange={setDashboardSelectedOperarioFilterId}
              onConsumptionClick={handleConsumptionClick}
            />
          </div>
        )}

        {currentPage === 'iniciarOperacion' && (
          <OperationStartForm
            operarios={operarios}
            operaciones={operaciones}
          />
        )}

        {currentPage === 'terminarOperacion' && (
          <OperationFinishForm
            operaciones={operaciones}
            operarios={operarios}
            onFinishOperation={handleFinishOperation}
            initialOperationId={selectedOperationToFinishId}
            clearInitialOperationId={() => setSelectedOperationToFinishId(null)}
          />
        )}

        {currentPage === 'operarioHistory' && (
          <OperarioHistory
            operarios={operarios}
            operaciones={operaciones}
          />
        )}

        {currentPage === 'plantasView' && (
          <div className="space-y-8">
            <PlantSelector
              plantas={plantas}
              selectedPlantId={selectedPlantId}
              onSelectPlant={handleSelectPlant}
            />
            {selectedPlantId && (
              <WorkCenterList
                centrosTrabajo={centrosTrabajoDePlanta}
                selectedWorkCenterId={selectedWorkCenterId}
                onSelectWorkCenter={handleSelectWorkCenter}
              />
            )}
            {selectedWorkCenterId && (
              <DashboardOperationList
                operaciones={operaciones}
                operarios={operarios}
                title={`Operaciones Pendientes en ${centrosTrabajoDePlanta.find(ct => ct.id === selectedWorkCenterId)?.nombre || 'Centro de Trabajo'}`}
                filterStatus="pendiente"
                filterCentroTrabajoId={selectedWorkCenterId}
                currentTime={currentTime}
                onStartPendingOperation={handleStartPendingOperationClick}
                selectedProductFilter={null}
                onProductFilterChange={() => {}}
                selectedOperarioFilterId={null}
                onOperarioFilterChange={() => {}}
                onConsumptionClick={handleConsumptionClick}
              />
            )}
          </div>
        )}

        {currentPage === 'statistics' && (
          <StatisticsDashboard
            operaciones={operaciones}
            operarios={operarios}
            plantas={plantas}
          />
        )}
      </main>

      {showOperarioSelectionModal && (
        <OperarioSelectionModal
          operarios={operarios}
          onSelect={handleOperarioSelectedForPending}
          onClose={() => setShowOperarioSelectionModal(false)}
        />
      )}

      {showUnitsInputModal && (
        <UnitsInputModal
          operationId={operationIdForUnitsInput}
          currentUnits={currentUnitsForUnitsInput}
          onConfirm={handleUnitsInputConfirm}
          onClose={() => setShowUnitsInputModal(false)}
          context={unitsInputModalContext}
        />
      )}

      {showConsumptionModal && (
        <ConsumptionModal
          operationId={selectedOperationIdForConsumos}
          initialConsumos={selectedOperationConsumos}
          onUpdateConsumos={handleUpdateConsumos}
          onClose={() => setShowConsumptionModal(false)}
        />
      )}
    </div>
  );
};

export default App;